// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3-Ng_","noInteraction":"EventWrapper_noInteraction__acBP_","pointerPassthrough":"EventWrapper_pointerPassthrough__2fAfC"};